// extracted by mini-css-extract-plugin
export default {"box":"Network_box__MnYc1","texts":"Network_texts__3oPfQ","img":"Network_img__Ku5Hd"};